module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAD9QTFRF////RkZd/0ZdR0dU/0tURUVU/0xURkZV/0tVmYxYmItY/2JWRkZV/0tVRkZV/0tVRkZV/0tVRkZV/0tV/+FaIzjifAAAABJ0Uk5TAAsLPT12drCwxcbG3d3l5f39RLszUgAAAGxJREFUOI3tk8kOgCAMRAeVxQXQ1v//VgkuiUZpvPOufW16mAEApW0gon69GJk5OtMg006UGe5Cwnd5PtOXwEsy1LH/KrBvoM/584cdA0ulC+wQykIElQWuQhX+CWLkxNCKsReLI1ZPLq9Q/w1vPEYJ3OxGtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/be.png
// module id = 2182
// module chunks = 0